export class LocationItem {
  constructor(itemData) {
    const searchTerm = `${itemData.properties.street_1} ${itemData.properties.city}, ${itemData.properties.state} ${itemData.properties.zip}`;

    this.data = itemData;
    this.mapUrl = `https://www.google.com/maps/search/?api=1&query=windsor+/${searchTerm}`;
    this.node = null;
    this.init();
  }

  init() {
    // Location Item wrapper
    this.node = document.createElement('div');
    this.node.classList.add('LocationsInRange__item');

    // Left and right section wrappers declaration
    const leftWrapper = document.createElement('div');
    leftWrapper.classList.add('LocationsInRange__left');

    const rightWrapper = document.createElement('div');
    rightWrapper.classList.add('LocationsInRange__right');

    // Start populating the left side content
    if (this.data.properties.name && this.data.properties.name !== 'false') {
      const link = document.createElement('a');
      link.classList.add('LocationsInRange__name');
      link.addEventListener('click', () => {
        const event = new CustomEvent('shouldFocusMarkerId', { detail: this.data.properties.store_number });
        document.dispatchEvent(event);
      });
      link.textContent = this.data.properties.name;
      leftWrapper.appendChild(link);
    }

    if (this.data.properties.street_1 && this.data.properties.street_1 !== 'false') {
      const street1 = document.createElement('div');
      street1.classList.add('LocationsInRange__street_1');
      street1.textContent = this.data.properties.street_1;
      leftWrapper.appendChild(street1);
    }

    if (this.data.properties.street_2 && this.data.properties.street_2 !== 'false') {
      const street2 = document.createElement('div');
      street2.classList.add('LocationsInRange__street_2');
      street2.textContent = this.data.properties.street_2;
      leftWrapper.appendChild(street2);
    }

    const cityStateZipPod = document.createElement('div');
    cityStateZipPod.classList.add('LocationsInRange__city-state-zip');
    cityStateZipPod.textContent = `${this.data.properties.city}, ${this.data.properties.state} ${this.data.properties.zip}`;
    leftWrapper.appendChild(cityStateZipPod);

    const chatWithUsPod = document.createElement('a');
    chatWithUsPod.classList.add('LocationsInRange__chat-message');
    chatWithUsPod.textContent = 'CHAT WITH US';
    chatWithUsPod.addEventListener('click', () => {
      window.adaEmbed.start({
        handle: 'windsorfashions-gen',
        metaFields: {
          username: 'Ada Lovelace',
          phone_number: '123-456-7890',
        },
        chatterTokenCallback: (chatter) => console.log(chatter),
      });

      window.adaEmbed.toggle();
    });
    leftWrapper.appendChild(chatWithUsPod);

    if (this.data.properties.store_number && this.data.properties.store_number.length > 0) {
      const storeNumberPod = document.createElement('div');
      storeNumberPod.classList.add('LocationsInRange__store-number');
      storeNumberPod.textContent = `Store #${this.data.properties.store_number}`;
      leftWrapper.appendChild(storeNumberPod);
    }

    // Populate Right side content
    if (this.data.properties.distance && this.data.properties.distance !== 'false') {
      const distancePod = document.createElement('div');
      distancePod.classList.add('LocationsInRange__distance');
      distancePod.textContent = `${Math.round(this.data.properties.distance * 10) / 10} mi`;
      rightWrapper.appendChild(distancePod);
    }

    const directionLink = document.createElement('a');
    directionLink.classList.add('LocationsInRange__directions');
    directionLink.target = '_blank';
    directionLink.rel = 'noopener nreferrer';
    directionLink.href = this.mapUrl;
    directionLink.textContent = 'Get Directions';
    rightWrapper.appendChild(directionLink);

    const detailsLink = document.createElement('a');
    detailsLink.classList.add('LocationsInRange__details');
    detailsLink.setAttribute('data-store', this.data.properties.name);
    detailsLink.rel = 'noopener';
    detailsLink.href = this.data.properties.url;
    detailsLink.textContent = 'Full Details';
    rightWrapper.appendChild(detailsLink);

    // Append left and right section to the parent node
    this.node.appendChild(leftWrapper);
    this.node.appendChild(rightWrapper);
  }
}
